module.exports = __webpack_public_path__ + "img/arrow-right-white.f1e65adc.svg";